import type { IconLoaders } from "../types";

/** Large icons on onboarding steps, empty states and setup cards */
export const featureIcons = {
    banknotes: () => import("./banknotes"),
    chart_trend: () => import("./chart_trend"),
    chat_bubble: () => import("./chat_bubble"),
    checklist: () => import("./checklist"),
    code_outline: () => import("./code_outline"),
    computer: () => import("./computer"),
    computer_desktop: () => import("./computer_desktop"),
    credit_card: () => import("./credit_card"),
    cursor_click: () => import("./cursor_click"),
    device_phone_mobile: () => import("./device_phone_mobile"),
    devices: () => import("./devices"),
    hierarchy: () => import("./hierarchy"),
    key_nodes: () => import("./key_nodes"),
    monitor: () => import("./monitor"),
    puzzle: () => import("./puzzle"),
    shopping_cart: () => import("./shopping_cart"),
    sliders: () => import("./sliders"),
    store_outline: () => import("./store_outline"),
    viewfinder_circle: () => import("./viewfinder_circle"),
    window_code: () => import("./window_code"),
} satisfies IconLoaders;
